const proyectos = [
  {
    nombre: "MediCalm",
    paginaWeb: "https://medicalm-analitycs.netlify.app",
    imagen: "/docs/proyectos/medicalm.jpeg",
    git: "https://github.com/Luci-fer666/Medicalm",
    descripcion: "Pagina web de analisis clinicos.",
    tecnologias: ["2025-2026", "N8N", "MongoDB", "Express", "React", "Node"]
  },
    {
    nombre: "Grogu Tech Store",
    paginaWeb: "https://grogutech.netlify.app",
    imagen: "/docs/proyectos/grogutech.jpeg",
    git: "https://github.com/Luci-fer666/GroguTechStore",
    descripcion: "Tienda digital web de venta de videojuegos.",
    tecnologias: ["2025-2026", "MongoDB", "Express", "React", "Node"]
  },
  {
    nombre: "Mueblería Hermanos Jota",
    paginaWeb: "https://hermanos-jota-ecomerce.netlify.app",
    imagen: "/docs/proyectos/hermanos.jpg",
    git: "https://github.com/Luci-fer666/Hermanos-Jota-Sping-7-8",
    descripcion: "Proyecto web e-commerce desarrollado de una muebleria",
    tecnologias: ["2025-2025", "MongoDB", "Express", "React", "Node"]
  },
  {
    nombre: "Lucifer ArtBook",
    paginaWeb: "https://lucifer-artbook.vercel.app",
    imagen: "/docs/proyectos/artbook.jpeg",
    git: "https://github.com/Luci-fer666/LuciferArtbook",
    descripcion: "Portfolio web de ilustracion. Muestra ilustraciones digitales y diseños.",
    tecnologias: ["2025-2025", "React", "Node"]
  },
  {
    nombre: "Luciano PortFolio",
    paginaWeb: "https://mi-portfolio-black.vercel.app",
    imagen: "/docs/proyectos/portfolio.jpg",
    git: "https://github.com/Luci-fer666/miPortfolio",
    descripcion: "Portfolio web para presentar conocimientos y habilidades. Esta misma web",
    tecnologias: ["2025-2025", "React", "Node"]
  },
  {
    nombre: "Formula Resolvente",
    paginaWeb: "https://github.com/Luci-fer666/Formula-Resolvente-Python-TKINTER",
    imagen: "/docs/proyectos/Screenshot1.jpeg",
    git: "https://github.com/Luci-fer666/Formula-Resolvente-Python-TKINTER",
    descripcion: "Aplicacion de Escritorio para calcular la formula resolvente",
    tecnologias: ["2024-2024", "TKinter", "Python"]
  },
  {
    nombre: "GameHub Solidario",
    paginaWeb: "https://game-hub-solidario.vercel.app",
    imagen: "/docs/proyectos/gamehub.jpg",
    git: "https://github.com/Luci-fer666/GameHub-Solidario",
    descripcion: "Proyecto de plataforma web solidaria de torneos de videojuegos",
    tecnologias: ["2025-2025", "HTML", "CSS", "JavaScript"]
  },
  {
    nombre: "CyberFest Festival 2025",
    paginaWeb: "https://cyberfest-lovat.vercel.app",
    imagen: "/docs/proyectos/cyberfest.jpg",
    git: "https://github.com/Luci-fer666/cyberfest",
    descripcion: "Proyecto de web para festival de musica electronica",
    tecnologias: ["2025-2025", "HTML", "CSS"]
  },
  {
    nombre: "Raiting Games",
    paginaWeb: "/proyectos",
    imagen: "/docs/proyectos/raiting.jpg",
    git: "/proyectos",
    descripcion: "NO DISPONIBLE. Pagina web de puntuacion de videojuegos",
    tecnologias: ["2024-2024", "PHP", "HTML", "CSS"]
  },

];

export default proyectos;